var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import qs from "qs";
export var paginationParams = function (params) {
    var _a = params.page, page = _a === void 0 ? "1" : _a, _b = params.size, size = _b === void 0 ? "10" : _b, rest = __rest(params, ["page", "size"]);
    return __assign(__assign({}, rest), { skip: String((+page - 1) * +size), limit: size });
};
export var mapQueryParams = function (params) {
    return __assign(__assign({}, paginationParams(params)), { sort: params.sort
            ? params.sort
            : {
                name: "asc",
            } });
};
export var makeUrlWithSearch = function (resource, params, mapQueryParams) {
    return "/" + resource + "?" + qs.stringify(mapQueryParams ? mapQueryParams(params) : params);
};
export var makeRepository = function (_a, apiSauceInstance) {
    var resource = _a.resource, specificMapQueryParams = _a.mapQueryParams;
    return {
        fetch: function (params) {
            return apiSauceInstance.get(makeUrlWithSearch(resource, params, specificMapQueryParams));
        },
        fetchOne: function (id) {
            return apiSauceInstance.get("/" + resource + "/" + id);
        },
        save: function (data) {
            if (data.id) {
                return apiSauceInstance.put("/" + resource + "/" + data.id, data);
            }
            return apiSauceInstance.post("/" + resource, data);
        },
        delete: function (id) { return apiSauceInstance.delete("/" + resource + "/" + id); },
    };
};
export var makeUrlWithParentId = function (resource, parendId) {
    return resource.replace(":id", String(parendId));
};
export var makeSubRepository = function (_a, apiSauceInstance) {
    var resource = _a.resource, specificMapQueryParams = _a.mapQueryParams;
    return {
        fetch: function (parendId, params) {
            return apiSauceInstance.get(makeUrlWithSearch(makeUrlWithParentId(resource, parendId), params, specificMapQueryParams));
        },
        fetchOne: function (parentId, id) {
            return apiSauceInstance.get("/" + makeUrlWithParentId(resource, parentId) + "/" + id);
        },
        save: function (parendId, data) {
            var url = makeUrlWithParentId(resource, parendId);
            if (data.id) {
                return apiSauceInstance.put("/" + url + "/" + data.id, data);
            }
            return apiSauceInstance.post("/" + url, data);
        },
        delete: function (parendId, id) {
            return apiSauceInstance.delete("/" + makeUrlWithParentId(resource, parendId) + "/" + id);
        },
    };
};
//# sourceMappingURL=makeRepository.js.map